const documentType = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
]

const currency = [
    { value: 'U$', text: 'Dólares' },
    { value: '¢', text: 'Colones' }
]


const hostname = window.location.hostname;
const isProductionCR = hostname.includes('appscr.seguroslafise.com');//PRO, ERROR ENTRE PRE Y PRO, CAMBIAN LOS PAQUETES
const plan = isProductionCR == false ? {
    colon: 551, //   Insurance COOPENAE 
    dolar: 552
} : {
    colon: 551, //   Insurance COOPENAE 
    dolar: 554
}


const statusV = [
    { value: '1', text: 'Nuevo' },
    { value: '0', text: 'Usado' }
]

export { documentType, currency, plan, statusV };